import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TechnicianService } from '../../../services/technician.service';
import { Time } from '@angular/common';
import moment from 'moment';

@Component({
  selector: 'app-add-edit-close-date',
  templateUrl: './add-edit-close-date.component.html',
  styleUrls: ['./add-edit-close-date.component.scss'],
})
export class AddEditCloseDateComponent implements OnInit {
  @Input() users;
  public startDate: any = '';
  public endDate: any = '';
  public description: any = '';
  public busy = false;

  constructor(
    public modal: NgbActiveModal,
    public technicianService: TechnicianService,
  ) {}

  ngOnInit() {}

  isValid() {
    return (
      this.startDate &&
      this.endDate &&
      this.description &&
      moment(this.endDate).toDate() >= moment(this.startDate).toDate()
    );
  }

  save() {
    //Some real dumb Ian code below, hard coding a closed date to 7 - 22 and using that as the way to identify a closed date...eish
    let startTimeDate = new Date(
      this.startDate.getFullYear(),
      this.startDate.getMonth(),
      this.startDate.getDate(),
      7,
      0,
      0,
    );
    //startTimeDate.setDate(startTimeDate.getDate() - 1);
    const startTime = startTimeDate.getTime();
    const endTime = new Date(
      this.startDate.getFullYear(),
      this.startDate.getMonth(),
      this.startDate.getDate(),
      22,
      0,
      0,
    ).getTime();
    this.busy = true;
    this.users.forEach((element) => {
      this.technicianService
        .createCalendarEvent(
          element.TechnicianID || element.id,
          this.description,
          moment(startTime).format('YYYY-MM-DDT07:00:00'),
          moment(endTime).format('YYYY-MM-DDT22:00:00'),
          true,
          moment
            .duration(
              moment(moment(this.endDate).add(1, 'days')).diff(
                moment(this.startDate),
              ),
            )
            .asDays(),
          1,
        )
        .subscribe(
          (event) => {
            this.busy = false;
            this.modal.close();
          },
          (err) => {
            this.busy = false;
          },
        );
    });
  }
}
